<template>
  <v-container
    fluid
    style="max-height: 90vh"
  >
    <v-row>
      <v-col
        cols="12"
      >
        <v-tabs
          v-model="tab"
        >
          <v-tab
          >
            Übersicht
          </v-tab>
          <v-tab>
            Tickets
          </v-tab>
          <v-tab>
            Workflow
          </v-tab>
          <v-tab
          >
            CMDB
          </v-tab>
          <v-tab-item>
            <Home @open-ci="open_ci_in_cmdb" @open-ticket="open_ticket"></Home>
          </v-tab-item>
          <v-tab-item
            class="secondary"
          >
            <v-container
              fluid
              class="px-0"
            >
              <v-row>
                <v-col
                  cols="12"
                  xs="12"
                  sm="5"
                  md="4"
                  lg="3"
                  xl="3"
                  class="mt-0 pr-0"
                >
                  <TicketList
                    v-model="current_ticket"
                    :tickets="tickets"
                  ></TicketList>
                </v-col>
                <v-col
                  cols="12"
                  xs="12"
                  sm="7"
                  md="8"
                  lg="9"
                  xl="9"
                  class="mt-0"
                >
                  <v-expand-transition>
                    <Ticket
                      v-if="current_ticket !== null"
                      :ticket="current_ticket"
                    ></Ticket>
                  </v-expand-transition>
                  <v-fab-transition>
                    <CreateTicket
                      v-if="current_ticket === null"

                    >
                    </CreateTicket>
                  </v-fab-transition>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item
            class="secondary"
          >
            <WorkflowTab></WorkflowTab>
          </v-tab-item>
          <v-tab-item
            class="secondary"
          >
            <CITab
              :requested_ci_id="requested_ci_id"
              @ci-changed="on_ci_changed"
            ></CITab>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Ticket from "../components/tickets/Ticket";
import TicketList from "../components/tickets/TicketList";
import CreateTicket from "../components/tickets/CreateTicket";
import Home from "../components/tickets/Home";

import CITab from "../components/tickets/cmdb/CITab";
import WorkflowTab from "../components/tickets/workflow/WorkflowTab";

export default {
  name: "TicketView",
  components: { WorkflowTab, CITab, Home, CreateTicket, TicketList, Ticket },
  methods: {
    open_ci_in_cmdb(id){
      this.active_ci_id = id
      this.requested_ci_id = { id, nonce: Date.now() }
      this.tab = 3
    },
    open_ticket(id){
      const t = this.$store.getters.get_ticket(id)
      if (t) {
        this.current_ticket = t
        this.tab = 1
      }
    },
    apply_route(){
      if (this.$route.name !== 'CMDBView') return
      this.tab = 3
      const raw = this.$route.params.id
      const id = raw != null && raw !== '' ? Number(raw) : null
      if (id != null && !Number.isNaN(id)) {
        this.active_ci_id = id
        this.requested_ci_id = { id, nonce: Date.now() }
      } else {
        this.active_ci_id = null
        this.requested_ci_id = null
      }
    },
    on_ci_changed(id){
      this.active_ci_id = id
      if (this.tab === 3) this.sync_cmdb_url(id)
    },
    sync_cmdb_url(id){
      const target = id != null ? String(id) : undefined
      if (this.$route.name === 'CMDBView' && (this.$route.params.id || undefined) === target) return
      this.$router.replace({ name: 'CMDBView', params: target ? { id: target } : {} }).catch(() => {})
    },
    sync_url_for_tab(tab){
      if (tab === 3) {
        this.sync_cmdb_url(this.active_ci_id)
      } else if (this.$route.name === 'CMDBView') {
        this.$router.replace({ name: 'TicketView' }).catch(() => {})
      }
    },
  },
  computed: {
    tickets() {
      return this.$store.state.ticketsystem.tickets
    },
  },
  data: () => ({
    tab: 0,
    current_ticket: null,
    requested_ci_id: null,
    active_ci_id: null,
  }),
  watch: {
    tickets: {
      handler() {
        if (this.current_ticket) {
          const updated = this.$store.getters.get_ticket(this.current_ticket.id)
          if (updated) this.current_ticket = updated
          else this.current_ticket = null
        }
      },
      deep: true,
    },
    $route: {
      handler(){ this.apply_route() },
      immediate: true,
    },
    tab(newTab){
      this.sync_url_for_tab(newTab)
    },
  },
  mounted() {
    if(this.$store.state.ticketsystem.users.length === 0)
      this.$store.dispatch("update", { "context": "/users" })
    if(this.$store.state.ticketsystem.cis.length === 0)
      this.$store.dispatch("update", { "context": "/cis" })
    this.$store.dispatch("update", { "context": "/tickets?filter_state=OPEN" })
  }
};
</script>

<style scoped>

</style>
